module.exports = __webpack_public_path__ + "media/images/common/confirm_btn_l-ef9c8da4c4f5213158e05678e277f064.png";